import type Client from "fhirclient/Client";

import config from "../config/config";
import { KEY_language } from "../constants";
import { clearPatientSession, toastError } from "./appService";
import { readFromStorage, removeFromStorage, writeToStorage } from "./storageServies";
import { getLanguageFromUrl, LogVerbose } from "./utilities";

// START: GitHub Copilot Generated Code
const loadFhirSdk = async () => {
    const module = await import("fhirclient/browser");
    return module.default;
};
// END: GitHub Copilot Generated Code

export const smartLaunch = (renderApp: (fhirClient?: Client, lang?: string | null) => void) => {
    const queryParams = new URL(window.location.href).searchParams;

    const iss = queryParams.get('iss');
    const launch = queryParams.get('launch');
    const code = queryParams.get('code');
    const state = queryParams.get('state');
    if (iss && launch) {
        clearPatientSession();
        LogVerbose(`Start SMART Launch. URL = ${window.location.href}`);
        const lang = getLanguageFromUrl(window.location.href);
        if (lang) {
            writeToStorage(KEY_language, lang);
            LogVerbose(`Start SMART Launch with Lang = ${lang} ...`);
        }
        else {
            LogVerbose(`Start SMART Launch ...`);
        }
        // START: GitHub Copilot Generated Code
        loadFhirSdk()
            .then((FHIR) => {
                FHIR.oauth2.authorize({
                    clientId: config.smart.clientId,
                    redirectUri: window.location.href.split('?')[0],
                    scope: config.smart.scope
                });
            })
            .catch((e) => {
                console.error(`Failed to initialize SMART Launch due to: ${JSON.stringify(e)}`);
                toastError('Failed to initialize SMART Launch. Patient-only experience is disabled.');
                renderApp(undefined, lang);
            });
        // END: GitHub Copilot Generated Code
    }
    else if (code && state) {
        LogVerbose(`Resume SMART Launch. URL = ${window.location.href}`);
        const lang = readFromStorage<string>(KEY_language);
        if (lang) {
            removeFromStorage(KEY_language);
            LogVerbose(`Resume SMART Launch with Lang = ${lang} ...`);
        }
        else {
            LogVerbose(`Resume SMART Launch ...`);
        }

        // START: GitHub Copilot Generated Code
        loadFhirSdk()
            .then((FHIR) => {
                FHIR.oauth2.ready()
                    .then((client: Client) => {
                        renderApp(client, lang);
                    })
                    .catch((e: unknown) => {
                        console.error(`Failed to start a session due to: ${JSON.stringify(e)}`);
                        toastError('Failed to sign in to MyMemorialHermann. Patient-only experience is disabled.');
                        renderApp(undefined, lang);
                    });
            })
            .catch((e) => {
                console.error(`Failed to load SMART Launch SDK due to: ${JSON.stringify(e)}`);
                toastError('Failed to sign in to MyMemorialHermann. Patient-only experience is disabled.');
                renderApp(undefined, lang);
            });
        // END: GitHub Copilot Generated Code
    }
    else {
        const lang = getLanguageFromUrl(window.location.href);
        if (lang) {
            LogVerbose(`Start App with Lang = ${lang} ...`);
        }
        else {
            LogVerbose(`Start App ...`);
        }
        renderApp(undefined, lang);
    }

};